import styled from 'styled-components';
import TextareaAutosize from 'react-autosize-textarea';

const AnswerField = styled(TextareaAutosize)`
color: ${(props) => props.theme.color.textSecondary};
background: #fff;
padding: .67857143em 1em;
width: 100%;
resize: none;
overflow-y: scroll;

:before {
  content: "...";
  font: "Roboto";
  font-size: 23pt;
  float: right;
}
`;

export {
  AnswerField,
};
